import { API } from "aws-amplify";
import { useEffect, useState } from "react";
import { PodSessionByType } from "../graphql/queries";
import { Box, Text, DataTable, Button, TextInput, Spinner } from "grommet";

const columns = [
  {
    property: "testerName",
    header: <Text>Tester Name</Text>,
    render: (datum) => (
      <Box direction="row">
        <Text size="small" truncate>
          {datum.testerName}
        </Text>
      </Box>
    ),
    align: "start",
    alignVertical: "middle",
    size: "medium",
  },
  {
    property: "organizationName",
    header: <Text>Organization</Text>,
    render: (datum) => (
      <Box direction="row">
        <Text size="small" truncate>
          {datum.organizationName}
        </Text>
      </Box>
    ),
    align: "start",
    alignVertical: "middle",
    size: "medium",
  },
  {
    property: "actions",
    header: <Text>Actions</Text>,
    render: (datum) => (
      <Box direction="row">
        <Button
          label="View Session"
          size="small"
          primary
          onClick={() => window.open(`/pod-session?id=${datum.id}`, "_blank")}
        />
      </Box>
    ),
    align: "start",
    alignVertical: "middle",
    size: "small",
  },
];

export default function Pod() {
  const [podSessions, setPodSessions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSessions, setFilteredSessions] = useState([]);

  useEffect(() => {
    const fetchAllPodSessions = async () => {
      setLoading(true);
      let allSessions = [];
      let token = null;
      let refetches = 0;

      try {
        do {
          console.log(refetches);
          const { data } = await API.graphql({
            query: PodSessionByType,
            variables: {
              type: "PodSession",
              sortDirection: "DESC",
              nextToken: token,
              limit: 300,
            },
          });

          const newSessions = data.podSessionByType.items;
          token = data.podSessionByType.nextToken;
          allSessions = [...allSessions, ...newSessions];
          refetches++;
        } while (token && refetches < 4);

        setPodSessions(allSessions);
        setFilteredSessions(allSessions);
      } catch (err) {
        console.error("Error fetching pod sessions:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchAllPodSessions();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm === "") {
        setFilteredSessions(podSessions);
      } else {
        const filtered = podSessions.filter(
          (session) =>
            session.testerName &&
            session.testerName.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredSessions(filtered);
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [searchTerm, podSessions]);

  return (
    <Box fill={true} pad="medium">
      <Box margin={{ bottom: "medium" }}>
        <Text size="large" weight="bold">
          Pod Sessions
        </Text>
      </Box>
      {loading && (
        <Box align="center" pad="large">
          <Spinner size="large" />
        </Box>
      )}
      {!loading && (
        <>
          <Box margin={{ bottom: "medium" }}>
            <TextInput
              placeholder="Search by tester name"
              value={searchTerm}
              onChange={(event) => setSearchTerm(event.target.value)}
            />
          </Box>
          <DataTable
            columns={columns}
            data={filteredSessions}
            primaryKey="id"
            step={10}
            fill={true}
            background={{
              header: { color: "light-2" },
              body: ["white", "light-1"],
            }}
          />
        </>
      )}
      {!loading && podSessions.length === 0 && (
        <Box align="center" pad="large">
          <Text size="medium" color="dark-4">
            No pod sessions found
          </Text>
        </Box>
      )}
    </Box>
  );
}
